if ($(window).width() > 749) {
  // Add class to allow transparent header
  var transperentElment = document.querySelector(".allow-transparent-header");
  var header = document.querySelector(".header-wrapper");
  var announcement_bar = document.querySelector(".announcement-bar-section");

  if (transperentElment) {
    if (header) {
      header.classList.add("allow-transparent-header");
    }
    if (announcement_bar) {
      announcement_bar.classList.add("allow-transparent-header");
    }
  }
}
 
///header menu hover ability js
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
});
});

//our policy page
document.addEventListener("DOMContentLoaded", function () {
  // Select all tab links and tab panes
  const tabLinks = document.querySelectorAll(".tab-link.hendle-title");
  const tabPanes = document.querySelectorAll(".tab-pane");

  // Add click event listeners to each tab link
  tabLinks.forEach(link => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      console.log("tab..click@@@@");
      // Get the target tab ID and title handle from the clicked link
      const titleHandle = link.getAttribute("data-title");
      console.log("titleHandle",titleHandle);
      // Remove 'current' class from all tab links and add it to the clicked link
      tabLinks.forEach(link => link.parentElement.classList.remove("current"));
      link.parentElement.classList.add("current");

      // Update the visibility of each tab pane
      tabPanes.forEach(pane => {
        if (pane.getAttribute("data-page-handle") === titleHandle) {
          console.log("tab..click active");
          pane.classList.add("active"); // Show the matching tab pane
        } else {
          pane.classList.remove("active"); // Hide other tab panes
        }
      });
    });
  });
});

  /// remove class in mobile mode of header transparent
  if ($(window).width() < 600) {
        document.querySelector('.header-wrapper').classList.remove('allow-transparent-header');
  }

  // product list slider
   new Swiper('.product_list_slider .swiper-container', {
      slidesPerView: 4,
      spaceBetween: 15,
      navigation: {
        nextEl: ".swiper-button-next.product-listss-next",
        prevEl: ".swiper-button-prev.product-listss-prev"
      },
      breakpoints: {
        991: {
            slidesPerView: 4,
            spaceBetween: 15
        },
        820: {
            slidesPerView: 3,
            spaceBetween: 15 
        },
        749: {
            slidesPerView: 2.3,
            spaceBetween: 10
        },
        0: {
            slidesPerView: 1.35,
            spaceBetween: 10 
        }
      },
      scrollbar: {
        el: ".swiper-scrollbar.js-swiper-scrollbar",
         "draggable": true
      }
   });

  // images gallery slider
  var gallery_slider = new Swiper(".autoplay-slider", {
  slidesPerView: 1.2,
  spaceBetween: 20,
  loop: true,
  freeMode: true, 
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  speed: 3000,
  autoplay: {
    delay: 0, 
    disableOnInteraction: false,
  },
  breakpoints: {
    820: {
      slidesPerView: 4.2, 
      spaceBetween: 20 
    },
    749: {
      slidesPerView: 3.2,
      spaceBetween: 10
    },
    0: {
      slidesPerView: 2,
      spaceBetween: 10
    }
  }
});

 // collection list slider
 if ($(window).width() > 769) {
     var gallery_slider = new Swiper(".collection-list-slider", {
      slidesPerView: 2.2,
      spaceBetween: 16,
      loop:false,
      navigation: {
        nextEl: ".swiper-button-next.collection-list-next", 
        prevEl: ".swiper-button-prev.collection-list-prev"
      } 
    });
  } 
  
 //card-product slider
 function cardSlider() {
 var swiper = new Swiper('.card-swipes', {
    loop: true, // Enables looping slides
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 1, // Display one slide at a time
    spaceBetween: 10, // Space between slides
  });
}
 cardSlider();

  // Header-drawer button trigger
  $('.header_menu-close').click(function() {
    $('.header-close-icon').trigger('click');
  });

  // Swatch limit for showing swatches
  var swatchLimit = 6;

  // Media image change on swatch click event
  function swatchMedia(){
    $('.swatch-input__input').click(function() {
      console.log("Swatch media....");
  
      // Get the data-image attribute from the swatch
      var dataImage = $(this).closest('.swatch-colors').attr('data-images');
      console.log("Images:", dataImage);
  
      // Find the main image in the current card wrapper
      var cardWrapper = $(this).closest('.card-wrapper');
      var mainImage = cardWrapper.find('.card__media img');
  
      // Check if the main image exists before updating
      if (mainImage.length) {
        console.log("mainImage:", mainImage);
        mainImage.attr('src', dataImage);
        mainImage.attr('srcset', dataImage);
      }
    });
     // More button click event
    $('.swatch-more-btn').click(function() {
      $('.swatch-colors').removeClass('swatch-hidden');
      $(this).addClass('hidden');
      $('.swatch-less-btn').removeClass('hidden');
    });
  
    // Less button click event
    $('.swatch-less-btn').click(function() {
      $('.swatch-colors').each(function(index) {
        if (index >= swatchLimit) {
          $(this).addClass('swatch-hidden');
        }
      });
      $(this).addClass('hidden');
      $('.swatch-more-btn').removeClass('hidden');
    });
  }
  swatchMedia();
  //gift card send gift btn trigger
  $('.send-gift-option').click(function(){
    $('.recipient-checkbox').trigger('click');
  })

  // product -grid logic 
     function toggleProductGridLayout() {
    const productGrid = document.getElementById('product-grid');
    const adjustmentButton = document.querySelector('.custom_grid_adjustment');

    let pdpGrid;
    let pdpGrid2;

    if (productGrid) {
        pdpGrid = productGrid.getAttribute('data-pdp-grid');
        pdpGrid2 = productGrid.getAttribute('data-pdp-grid-2');
    }

    if (adjustmentButton) {
        adjustmentButton.addEventListener('click', function() {
            // Find the current grid layout class
            const currentGridClass = Array.from(productGrid.classList).find(className => className.includes('grid--'));

            if (currentGridClass === `grid--${pdpGrid}-col-desktop`) {
                // Switch to the second grid layout
                productGrid.classList.remove(currentGridClass);
                productGrid.classList.add(`grid--${pdpGrid2}-col-desktop`);
                productGrid.setAttribute('desktop-grid', pdpGrid2);
            } else {
                // Switch back to the first grid layout
                productGrid.classList.remove(currentGridClass);
                productGrid.classList.add(`grid--${pdpGrid}-col-desktop`);
                productGrid.setAttribute('desktop-grid', pdpGrid);
            }
        });
    } else {
        console.warn('Adjustment button not found.'); 
    }
}
  // Call the function to set up the grid layout toggle
  toggleProductGridLayout();


//product main media slider
// Initialize the main product swiper
// Main product swiper
// Initialize the main product slider
// Initialize the main media slider with mousewheel support
// Initialize the main product slider


(function() {
pdp_slider();
})();

function pdp_slider(){
var Product_swiper = new Swiper(".custom_slider_pdp", {
    slidesPerView: 1,
    spaceBetween: 10,
    direction: "vertical",
    keyboard: {
        enabled: true,
        onlyInViewport: true
    },
    allowTouchMove: true,
    speed: 500,
    mousewheel: {
        invert: false,
        forceToAxis: true,
        sensitivity: 1
    },
    navigation: {
        nextEl: ".swiper-button-next.main",
        prevEl: ".swiper-button-prev.main"
    },
    scrollbar: {
        el: ".swiper-scrollbar.main",
        draggable: true
    },
    thumbs: {
        swiper: null
    },
    breakpoints: {
      1025: {
          direction: "vertical"
      },
      320: {
          direction: "horizontal"
      }
   }
});

// Check if the thumbnail slider exists
if (document.querySelector(".swiprt_thumbnail_slider")) {
    var Thumbnail_swiper = new Swiper(".swiprt_thumbnail_slider", {
        slidesPerView: 4,
        spaceBetween: 20,
        watchSlidesProgress: true,
        slideThumbActiveClass: "swiper-slide-thumb-active",
        breakpoints: {
            0: {
                slidesPerView: 4,
                direction: "horizontal"
            },
            1025: {
                slidesPerView: 5,
                direction: "vertical"
            }
        },
        navigation: {
            nextEl: ".swiper-button-next.thumb",
            prevEl: ".swiper-button-prev.thumb"
        },
        mousewheel: {
            invert: false,
            forceToAxis: true,
            sensitivity: 1
        }
    });

    // Link thumbnail swiper to the main product swiper
    Product_swiper.thumbs.swiper = Thumbnail_swiper;

    // Update the main slider and select box when clicking on a thumbnail
    Thumbnail_swiper.on("click", (swiper, event) => {
        const clickedIndex = swiper.clickedIndex;
        if (clickedIndex !== undefined && clickedIndex !== null) {
            Product_swiper.slideTo(clickedIndex);

            // Update select box
            const selectBox = document.querySelector("#product-select-box");
            if (selectBox) {
                selectBox.selectedIndex = clickedIndex;
                selectBox.dispatchEvent(new Event("change")); // Trigger change event
            }
        }
    });

    // Update main slider and select box when scrolling the thumbnail slider
    Thumbnail_swiper.on("slideChange", () => {
        const activeIndex = Thumbnail_swiper.activeIndex;

        // Update main slider
        Product_swiper.slideTo(activeIndex);

        // Update select box
        const selectBox = document.querySelector("#product-select-box");
        if (selectBox) {
            selectBox.selectedIndex = activeIndex;
            selectBox.dispatchEvent(new Event("change"));
        }
    });
}
}

// Cross-media slider synchronization
if (document.querySelector(".cross_media_slider")) {
    var CrossMedia_swiper = new Swiper(".cross_media_slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        allowTouchMove: true,
        speed: 500,
        navigation: {
            nextEl: ".swiper-button-next.cross-media",
            prevEl: ".swiper-button-prev.cross-media"
        }
    });

    // Synchronize with thumbnail slider
    Thumbnail_swiper.on("slideChange", () => {
        const activeIndex = Thumbnail_swiper.activeIndex;
        CrossMedia_swiper.slideTo(activeIndex);
    });

    CrossMedia_swiper.on("slideChange", () => {
        const activeIndex = CrossMedia_swiper.activeIndex;
        Thumbnail_swiper.slideTo(activeIndex);
    });
}// end main pdp slider

// product product-recommendations slder
/* 
  setTimeout(function() {
    if (document.querySelector('.related-products .releted-slider')) {
      new Swiper('.related-products .releted-slider', {
        slidesPerView: 4,
        spaceBetween: 15,
         loop: false, 
        breakpoints: {
          991: {
              slidesPerView: 4,
              spaceBetween: 15
          },
          820: {
              slidesPerView: 3,
              spaceBetween: 15 
          },
          749: {
              slidesPerView: 2.3,
              spaceBetween: 10
          },
          0: {
              slidesPerView: 1.3,
              spaceBetween: 10 
          }
        },
        scrollbar: {
          el: ".swiper-scrollbar.js-swiper-scrollbar",
        }
      });
    }
  }, 3000); // Delay of 1000ms (1 second) */

// learn more btn logic in pdp page 
    const learnMoreBtn = document.getElementById('learn-more-btn');
    const shortDescription = document.querySelector('.short-description');
    const fullDescription = document.querySelector('.full-description');

    if (learnMoreBtn) {
        learnMoreBtn.addEventListener('click', function () {
            if (fullDescription.style.display === 'none') {
                fullDescription.style.display = 'block';
                shortDescription.style.display = 'none';
                learnMoreBtn.textContent = 'Show Less';
            } else {
                fullDescription.style.display = 'none';
                shortDescription.style.display = 'block';
                learnMoreBtn.textContent = 'Learn More';
            }
        });
    }


  if (!localStorage.getItem('firstLoad')) {
    $(".custom-model-main").addClass('model-open');
    localStorage.setItem('firstLoad', 'true');
  }
  $(".close-btn, .bg-overlay").click(function(){
    $(".custom-model-main").removeClass('model-open');
  });

/* //newsletter unsubscribe trigger 
  document.addEventListener("DOMContentLoaded", function () {
    // Select the specific text link by class
    const dnssmpiLink = document.querySelector(".footer-bottom-menu .klaviyo-unsub-form");
  
    if (dnssmpiLink) {
      // Add a click event listener to the link
      dnssmpiLink.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent the default link behavior
         window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'YkS274']);
      });
    }
  }); */

//blog slider 

document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".blog-swiper", {
    slidesPerView: 1,
     loop: false,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: { slidesPerView: 1 },
      750: { slidesPerView: 2 },
      990: { slidesPerView: 3 },
      1200: { slidesPerView: 3 },
    }
  });
});
